import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, MapPinIcon } from 'lucide-react';
import { LinkedInIcon } from './LinkedInIcon';
import { contactDetails, navItems } from '../data/content';
import { services } from '../data/services';
export function Footer() {
  return <footer className="bg-navy-900 text-white/70" data-id="element-50" data-mp="36p6df098t0cq">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 lg:grid-cols-12 lg:px-8" data-id="element-51" data-mp="36pzaf9iegbho">
        <div className="lg:col-span-5" data-id="element-52" data-mp="3ugbqx8rpngjv">
          <p className="font-serif text-2xl text-white" data-id="element-53" data-mp="3ud7iu0b4k0nx">Dr. Tom Vecchione</p>
          <p className="mt-2 text-xs font-medium uppercase tracking-[0.2em] text-gold" data-id="element-54" data-mp="37xwcimca4j2">Ph.D. · CPRW · CIC · CDCS</p>
          <p className="mt-6 max-w-sm text-sm leading-relaxed" data-id="element-55" data-mp="3lgop4lv2k8qa">
            Executive Career Advising Specialist and former Higher Education Executive Director, helping leaders
            position their value for the roles that define a career.
          </p>
        </div>

        <nav className="lg:col-span-2" aria-label="Footer" data-id="element-56" data-mp="2ezuubn1oaam9">
          <p className="text-sm font-semibold text-white" data-id="element-57" data-mp="3l90pe0juz71d">Navigate</p>
          <ul className="mt-4 space-y-3 text-sm" data-id="element-58" data-mp="3lbdb8osqm1jp">
            {navItems.map(item => <li key={item.to} data-id="element-59" data-mp="3gctq2qlywtse">
                <Link to={item.to} className="transition-colors duration-150 hover:text-white" data-id="element-60" data-mp="3v89f2h7oxzhx">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <div className="lg:col-span-3" data-id="element-61" data-mp="828mq5huy395">
          <p className="text-sm font-semibold text-white" data-id="element-62" data-mp="8178js5jp0n7">Advisory</p>
          <ul className="mt-4 space-y-3 text-sm" data-id="element-63" data-mp="335szh7bvjgh">
            {services.map(s => <li key={s.id} data-id="element-64" data-mp="ht3dnn61tr0x">
                <Link to={`/services#${s.id}`} className="transition-colors duration-150 hover:text-white" data-id="element-65" data-mp="hs1yp7lwwkdx">
                  {s.title.split(' & ')[0]}
                </Link>
              </li>)}
          </ul>
        </div>

        <div className="lg:col-span-2" data-id="element-66" data-mp="mrwrxht5tm25">
          <p className="text-sm font-semibold text-white" data-id="element-67" data-mp="msy4jqptqglz">Connect</p>
          <ul className="mt-4 space-y-3 text-sm" data-id="element-68" data-mp="tvcw1hybznae">
            <li data-id="element-69" data-mp="twxu3hjutod0">
              <a href={`mailto:${contactDetails.email}`} className="inline-flex items-center gap-2 hover:text-white" data-id="element-70" data-mp="tt9zef2oavwp">
                <MailIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-71" data-mp="13tke644cwbdz" />
                Email
              </a>
            </li>
            <li className="inline-flex items-center gap-2" data-id="element-72" data-mp="18ksor3hfa2sq">
              <MapPinIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-73" data-mp="1clunzkbcaeup" />
              Woodstock, GA
            </li>
            <li data-id="element-74" data-mp="1hjnvcgodpewk">
              <a href={contactDetails.linkedin} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-white" data-id="element-75" data-mp="1hj4cmxqwmmhh">
                <LinkedInIcon className="h-4 w-4 text-gold" data-id="element-76" data-mp="1rgsgcd6hn4bs" />
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10" data-id="element-77" data-mp="3tb9l5new1lsp">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-6 text-xs sm:flex-row sm:justify-between lg:px-8" data-id="element-78" data-mp="3tc2umw58epej">
          <p data-id="element-79" data-mp="25nvhspq1pa4c">© 2026 Dr. Tom Vecchione · Write for Me Resumes. All rights reserved.</p>
          <p data-id="element-80" data-mp="21mti67s7uw1u">
            {contactDetails.email} · {contactDetails.location}
          </p>
        </div>
      </div>
    </footer>;
}